/**
 * Contact Form functionality
 */

export function initContactForm() {
    // Set data-label attributes for persistent labels with custom values
    const labelMap = {
        'nom': 'Nom',
        'email': 'Email', 
        'sujet': 'Sujet',
        'telephone': 'Tél.',
        'message': 'Message'
    };
    
    function setLabels() {
        const formFields = document.querySelectorAll('.form-field');
        formFields.forEach(field => {
            const input = field.querySelector('.form-input, .form-textarea');
            if (input && input.name) {
                const label = labelMap[input.name] || input.name;
                field.setAttribute('data-label', label);
            }
        });
    }
    
    // Run immediately
    setLabels();
    
    // Also run when popup opens
    document.addEventListener('click', function(e) {
        if (e.target.closest('#contactBtn') || e.target.closest('a[href="#contact"]')) {
            setTimeout(setLabels, 100);
        }
    });
}